import { JOBS_QUEUE_STATUS } from './jobs-queue-status.enum';

export class JobsQueue {
  queueStatus: JOBS_QUEUE_STATUS;
  numberOfMessages: number;

  constructor(data: JobsQueue | DjangoJobsQueue = {}) {
    if (data instanceof JobsQueue) {
      bindJobsQueueData(this, data);
    } else {
      bindDjangoJobsQueueData(this, data);
    }
  }
}

export function parseJobsQueue(data?: JobsQueue | DjangoJobsQueue) {
  if (data) {
    return new JobsQueue(data);
  } else {
    return undefined;
  }
}

function bindJobsQueueData(jobsQueue: JobsQueue, data: JobsQueue) {
  jobsQueue.queueStatus = data.queueStatus;
  jobsQueue.numberOfMessages = data.numberOfMessages;
}

///////////////////
// DJANGO SUPPOT //
///////////////////
export interface DjangoJobsQueue {
  queue_status?: JOBS_QUEUE_STATUS;
  number_of_messages?: number;
}

function bindDjangoJobsQueueData(jobsQueue: JobsQueue, data: DjangoJobsQueue) {
  jobsQueue.queueStatus = data.queue_status;
  jobsQueue.numberOfMessages = data.number_of_messages;
}
